import { mapActions, mapGetters } from 'vuex';

const TABS_ID = {
	ALL: -1,
	EVENTS: 0,
	PROGRAMMES: 1,
	MEDIA: 2,
};

export default {
	props: {
		propActiveTab: {
			type: Number,
			default: TABS_ID.ALL,
		},
	},
	data() {
		return {
			page: 1,
			visible: false,
			recommendationsData: null,
			recommendationsList: [],
			isShowRecommendations: false,
			selectedTags: [],
			selectedTagsParent: [],
			activeTab: TABS_ID.ALL,
			TABS_ID,
		};
	},
	watch: {
		selectedTags: {
			handler() {
				this.isShowRecommendations = true;
				this.getRecommendations();
			},
		},
		propActiveTab: {
			handler(value) {
				this.activeTab = value;
			},
			immediate: true,
		},
	},
	computed: {
		...mapGetters('profile', ['personalRecommendations']),
	},
	methods: {
		...mapActions({
			getPersonalRecommendations: 'profile/getPersonalRecommendations',
		}),
		async getRecommendations(tab = this.activeTab) {
			this.page = 1;
			const isTagsEqualInStore = this.personalRecommendations?.length === this.selectedTags?.length
				&& this.selectedTags.every((tag) => this.personalRecommendations.includes(tag));

			await this.$api.getUserRecommendations(this.getData(tab))
				.then((res) => {
					this.recommendationsData = res;
					this.$emit('updateRecommendationsData',
						{ list: this.recommendationsData?.data, tags: this.selectedTags });
				});

			if (this.$auth.user && !isTagsEqualInStore) {
				const formData = new FormData();
				this.selectedTags.forEach((tag, index) => {
					formData.append(`values[user_recommendations][${index}]`, tag);
				});

				if (!this.selectedTags.length) {
					formData.append('values[user_recommendations][0]', '');
				}
				await this.$api.setUserProfileFields(formData);
			}
		},
		getData(tab) {
			let data = {};
			const typologies = tab;
			const {
				ALL, EVENTS, PROGRAMMES, MEDIA,
			} = TABS_ID;

			data = {
				filters: [
					...this.selectedTags.map((tag) => ({
						type: 'taxonomyOptions',
						value: tag,
					})),
				],
				typologies: typologies === ALL ? [EVENTS, PROGRAMMES, MEDIA] : [typologies],
				page: this.page,
			};
			return data;
		},
		handleRecommendationsData(data) {
			// Запись данных для родительского блока с отображением списка
			this.recommendationsList = data.list;
			this.selectedTagsParent = data.tags;
		},
		getDynamicDataWithTags(initialData) {
			// Список родительского блока
			const isListWithTags = this.recommendationsList.length && this.selectedTagsParent.length;
			return isListWithTags ? this.recommendationsList : initialData;
		},
		async resetTags() {
			this.selectedTags = [];

			await this.getRecommendations();
			await this.getPersonalRecommendations();
		},
	},

};
// @vue/component
